import React, { createContext, useContext, useMemo } from 'react';
import { getActivityId } from '../utils/autoLayout';

const BoardActivitiesContext = createContext({
  activities: [],
  loadedTime: null,
  activityById: () => null,
});

export function BoardActivitiesProvider({ activities, loadedTime, children }) {
  const value = useMemo(() => {
    const map = new Map(activities.map(activity => [getActivityId(activity), activity]));
    return {
      activities,
      loadedTime,
      activityById: id => map.get(String(id)) ?? null,
    };
  }, [activities, loadedTime]);

  return (
    <BoardActivitiesContext.Provider value={value}>{children}</BoardActivitiesContext.Provider>
  );
}

export function useBoardActivities() {
  return useContext(BoardActivitiesContext);
}
